import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { parsePhoneNumber } from "@jti/fe-common";
import { selectAccountContact, useSelector } from "@jti/store";
import { Telephone, useConfig, useFormContext } from "@jti/ui";
import styles from "./PrefilledPhoneContact.module.scss";
const TELEPHONE_PREFIX = "editPhone";
export const PrefilledPhoneContact = ({ telephone, dataTestId = "", isPhoneNumberRequired = true, }) => {
    const config = useConfig();
    const { setValue, watch } = useFormContext();
    const accountContact = useSelector(selectAccountContact);
    const { value } = watch(`${TELEPHONE_PREFIX}.code`) || {};
    const phone = watch(`${TELEPHONE_PREFIX}.phone`);
    useEffect(() => {
        const [prefixPhoneNumber, nationalPhoneNumber] = parsePhoneNumber(config.TELEPHONE_CODES_LIST, telephone || accountContact?.telephone);
        if (nationalPhoneNumber) {
            setValue(`${TELEPHONE_PREFIX}.code`, {
                label: prefixPhoneNumber,
                value: prefixPhoneNumber,
            });
            setValue(`${TELEPHONE_PREFIX}.phone`, nationalPhoneNumber);
        }
    }, []);
    useEffect(() => {
        if (value && phone) {
            setValue(`shippingContact.telephone`, `${value}${phone}`);
        }
    }, [value, phone, setValue]);
    return (_jsx("div", { className: styles.prefilledPhoneContact, "data-testid": dataTestId, children: _jsx(Telephone, { isWithoutDropdown: false, fieldName: (name) => `${TELEPHONE_PREFIX}.${name}`, isRequired: isPhoneNumberRequired }) }));
};
//# sourceMappingURL=PrefilledPhoneContact.js.map